/**
 * Entidade de Domínio: User
 * Representa um usuário do CRM com suas regras de negócio
 */

export class User {
    constructor(
        public readonly id: string,
        public readonly name: string,
        public readonly email: string,
        public readonly role: 'admin' | 'agent',
        public readonly lastAccess: Date,
        public readonly phone: string | null = null
    ) {
        this.validate();
    }

    private validate(): void {
        if (!this.id || this.id.trim() === '') {
            throw new Error('User ID is required');
        }

        if (!this.name || this.name.trim() === '') {
            throw new Error('User name is required');
        }

        if (!this.isValidEmail(this.email)) {
            throw new Error('Invalid email format');
        }
    }

    private isValidEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    get accessType(): string {
        return this.role === 'admin' ? 'Administrador' : 'Atendente';
    }

    get formattedLastAccess(): string {
        return this.lastAccess.toLocaleString('pt-BR');
    }

    isAdmin(): boolean {
        return this.role === 'admin';
    }

    canDelete(): boolean {
        // Regra de negócio: admin não pode ser deletado se for o único
        return !this.isAdmin();
    }
}
